import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output, TemplateRef } from '@angular/core';
import { Event, NavigationEnd, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@spotter/services/internal/language-service';
import { AuthService } from '@spotter/services/user/auth-service';

type AccessLevel = 'public' | 'authOnly' | 'adminOnly';

interface SecondLevelLink {
    title: string;
    routerLink: string;
    accessRights?: AccessLevel;
    translate?: boolean;
}

interface TopLevelLink {
    id: string;
    title: string;
    icon: IconProp;
    routerLink: string;
    translate?: boolean;
    items?: SecondLevelLink[];
}



interface SidebarSection {
    title: string;
    accessRights: AccessLevel;
    translate?: boolean;
    items: TopLevelLink[];
}

export interface SidebarLayout {
    sections: SidebarSection[];
}

type CollapseState = {
    isCollapsed: boolean;
    routerBase: string;
  };


@Component({
    selector: 'site-sidebar',
    standalone: true,
    imports: [CommonModule, FontAwesomeModule, NgbModule, RouterModule, TranslateModule],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {

      @Input() mobile: boolean = false;

      @Input() sidebarLayout: SidebarLayout = {sections: []};
      @Input() sidebarContent?: TemplateRef<any>;

      @Input() showSpotterAppStorelinks: boolean = false;
      @Input() showTranslationDropdown: boolean = false;

      @HostBinding('style.overflow') get overflowStyle() {
        return this.mobile ? 'scroll' : 'visible';
      }

    collapsedStates: Record<string, CollapseState> = {}; // Tracks collapse states

      @Output() routerNavigated:  EventEmitter<void> = new EventEmitter<void>();

   // layout?: SidebarLayout;

    constructor(private router: Router, public auth: AuthService, public languageService: LanguageService) {

       

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd)
            {

                Object.entries(this.collapsedStates).forEach(([id, collapseState]) => {
                    collapseState.isCollapsed = !event.urlAfterRedirects.startsWith(collapseState.routerBase)
                  });
                  

             //   this.collapsedStates.forEach()
                // this.sightingsCollapsed = !event.urlAfterRedirects.startsWith("/sightings");
                // this.adminCollapsed = !event.urlAfterRedirects.startsWith("/admin");
                // this.absencesCollapsed = !event.urlAfterRedirects.startsWith("/absences");
                // this.dataCollapsed = !event.urlAfterRedirects.startsWith("/data");
                // this.toolsCollapsed = !event.urlAfterRedirects.startsWith("/tools");
                this.routerNavigated.emit();
            }
        });

    }

    ngOnInit()
    {
 // Create the collapses defaulting to collapsed
 this.sidebarLayout.sections.forEach(section => {
    section.items.forEach(tl => {
        this.collapsedStates[tl.id] = {routerBase: tl.routerLink, isCollapsed: true};
    });
});
    }


    toggleCollapse(id: string) {
        this.collapsedStates[id].isCollapsed = !this.collapsedStates[id].isCollapsed;
    }

    switchLanguage(code: string)
    {
        window.localStorage.setItem("language", code);
        window.location.reload();
    }  

}
